import {
    getProducts,
    addTaeg,
    deleteTaeg,
    getTAEGAllowed,
    getISCD,
    addIscd,
    deleteIscd,
    getTransversal,
    saveTransversal
} from "../../api/backoffice";

import i18n from "@/i18n"

const CLIENT_TYPES = [
    {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
    },
    {
        value: 1,
        text: "Particular",
    },
    {
        value: 2,
        text: "ENI",
    },
    {
        value: 3,
        text: "Empresa",
    },
];

const getDefaultState = () => {
    return {
        financialData: {
            taegAllowed: {},
            iscd: {},
            transversal: {}
        },
        products: [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }
        ],
        vehicleTypesOptions: [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: "Novo",
                text: i18n.t("Novo"),
            },
            {
                value: "Usado",
                text: i18n.t("Usado"),
            },
        ],
        clientTypesOptions: CLIENT_TYPES,
        clientTypes: [
            {
                value: 1,
                text: "Particular",
            },
            {
                value: 2,
                text: "ENI",
            },
            {
                value: 3,
                text: "Empresa",
            },
        ],
    };
};

const state = getDefaultState();

const getters = {
    getFinancialDataTAEG: (state) => {
        return state.financialData?.taegAllowed;
    },
    getProducts: (state) => state.products,
    getVehicleTypesOptions: (state) => state.vehicleTypesOptions,
    getFinancialDataISCD: (state) => {
        return state.financialData?.iscd;
    },
    getClientTypesOptions: (state) => state.clientTypesOptions,
    getClientTypes: (state) => state.clientTypes,
    getFinancialDataTransversal: (state) => state.financialData.transversal
};

const mutations = {
    setFinancialData(state, financialData) {
        state.financialData = financialData;
    },
    setFinancialTaeg(state, financialData) {
        state.financialData.taegAllowed = financialData?.taegAllowed?.map((taeg, index) => {
            return {
                id: index,
                ...taeg,
                max_rate_simple: taeg?.max_rate,
                disabled: true,
                newRow: false,
                productOptions: state.products,
                vehicleTypesOptions: state.vehicleTypesOptions
            }
        });
    },
    setFinancialISCD(state, financialData) {
        state.financialData.iscd = financialData?.iscd?.map((iscd, index) => {
            return {
                id: index,
                ...iscd,
                product: state?.products?.find((prod) => prod.value === iscd?.ivIdProduct)?.text,
                disabled: true,
                newRow: false,
                productOptions: state.products,
                dtStart: iscd?.ivDtStarted,
                clientType: state?.clientTypesOptions?.find((prod) => prod.value === iscd?.ivIdClientType)?.text,
                clientTypesOptions: state.clientTypesOptions
            }
        });
    },
    setFinancialTransversal(state, transversalData) {
        state.financialData.transversal = transversalData;
    },
    resetProducts(state) {
        state.products = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }
        ]
    },
    resetClientTypes(state) {
        state.clientTypesOptions = CLIENT_TYPES;
    },
    setProducts(state, responseData) {
        responseData.map((product) => {
            state.products.push({
                value: product.ID,
                text: product.NAME,
            })
        })
    },
    setProductsWithProductId(state, {responseData, idProduct}) {
        if (responseData) {
            responseData.map((product) => {
                console.log(idProduct, product.ID);
                if (idProduct) {
                    if (idProduct === product.ID) {
                        state.products.push({
                            value: product.ID,
                            text: product.NAME,
                        })
                    }
                } else {
                    state.products.push({
                        value: product.ID,
                        text: product.NAME,
                    })
                }
            })
        }
    },
    setClientTypeOptions(state, idClient) {
        const clientTypes = [{
            value: -1,
            text: i18n.t("dropdownSelection"),
            disabled: true,
        }];
        state.clientTypesOptions.filter((clientType) => {
            if (idClient) {
                if (idClient === clientType.value) {
                    clientTypes.push(clientType);
                }
            } else {
                clientTypes.push(clientType);
            }
        });
        state.clientTypesOptions = clientTypes;
    },
    addRowToTable(state, {newRow, tableName}) {
        const maxID = state.financialData?.[tableName].reduce((max, row) => {
            return row.id > max ? row.id : max;
        }, 0);
        newRow.id = maxID + 1;

        state.financialData?.[tableName].unshift(newRow);
    },
    removeFirstRowFromTAEG(state) {
        state.financialData?.taegAllowed.shift();
    },
    removeFirstRowFromISCD(state) {
        state.financialData?.iscd.shift();
    },
    setTransversalData(state, {inputField, inputData}) {
        state.financialData.transversal[inputField] = inputData;
    }
};

const actions = {
    async getTAEGAllowed({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getTAEGAllowed(idInstance);
            const responseData = response?.data?.data;
            commit("setFinancialTaeg", responseData);

            return responseData;
        } catch (error) {
            console.log(error)
        }
    },
    async getISCD({commit}, queryString) {
        try {
            const response = await getISCD(queryString);
            const responseData = response?.data?.data;
            commit("setFinancialISCD", responseData);

            return responseData;
        } catch (error) {
            console.log(error)
        }
    },
    async getTransversal({commit}) {
        try {
            const response = await getTransversal();
            const responseData = response?.data?.data;
            commit("setFinancialTransversal", responseData);

            return responseData;
        } catch (error) {
            console.log(error)
        }
    },
    async getProducts({ commit, rootGetters }, {idProduct, fromISCDTable}) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getProducts(idInstance);
            commit("resetProducts");
            fromISCDTable ? commit("setProductsWithProductId", {responseData: response?.data?.data, idProduct}) :
                commit("setProducts", response?.data?.data);

            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    getClientTypes({commit}, idClient) {
        try {
            commit("resetClientTypes");
            commit("setClientTypeOptions", idClient);
        } catch (error) {
            console.log(error)
        }
    },
    async addTaeg({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addTaeg(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async addIscd({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addIscd(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteTaeg({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await deleteTaeg(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteIscd({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await deleteIscd(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async saveTransversal({commit}, { payload, origin }) {
        commit("setTableLoading", false);
        try {
            const response = await saveTransversal(payload, origin);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
